import Rating, { IconContainerProps } from '@material-ui/core/Rating';
import { ReactElement, useState } from 'react';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';
import { customIcons, colors } from './IconList';
import { RatingInterface } from './interface/Rating';
import { DivStyled, Text } from './Rating';
import useDebounce from '../../hooks/useDebounce';

export default function Answer({ title, onChange, IconContainerComponent, assesment=-1 }: RatingInterface) {

  const [icons, setIcons] = useState<{
    [index: string]: {
      icon: ReactElement;
    };
  }>(customIcons);
  const [value, setValue] = useState<number | null>(assesment< 0 ? -1 : assesment);

  function IconContainer(props: IconContainerProps) {
    const { value, ...other } = props;
    return <span {...other} >{value <= assesment ? icons[value].icon : icons[0].icon}</span>;
  }

  const iconSelect = (hover: number) => {
    let iconsAux: {
      [index: string]: {
        icon: ReactElement;
      };
    } = { ...icons };
    if (hover > 0) {
      colors.map((color: string, index: number) => {
        iconsAux[index + 1] = {
          icon: <AiFillStar color={hover <= index ? 'rgba(0, 0, 0, 0.26)' : color} size={40} />
        };
        return color;
      });
    }
    if (value && hover < 0) {
      colors.map((color: string, index: number) => {
        iconsAux[index + 1] = {
          icon: <AiFillStar color={value <= index ? 'rgba(0, 0, 0, 0.26)' : color} size={40} />
        };
        return color;
      });
    }
    !value && hover < 0 ? setIcons(customIcons) : setIcons(iconsAux);
  }

  const debounce = useDebounce(iconSelect, 100);

  return (
    <DivStyled>
      <Text > {title} </Text>
      <Rating
        name="customized-color"
        defaultValue={11}
        value={assesment < 0 ? value : assesment}
        precision={1}
        disabled={assesment < 0 ? false : true}
        icon={<AiFillStar size={28} />}
        onChange={(event, newValue) => {
            onChange(newValue);
            setValue(newValue);
        }}
        readOnly={assesment < 0 ? false : true}
        onChangeActive={IconContainerComponent ? (event, newHover) => {
            debounce(newHover);
        } : undefined}
        IconContainerComponent={IconContainerComponent ? IconContainer : undefined}
        emptyIcon={<AiOutlineStar size={28} />}
        max={IconContainerComponent ? 11 : 5}
      />
    </DivStyled>
  )
}
